import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  InputLabel,
  Select,
  MenuItem,
  Divider
} from "@material-ui/core";
import {
  Menu as MenuIcon,
  Person as AccountIcon,
  ArrowBack as ArrowBackIcon,
  Transform as PublisherChange
} from "@material-ui/icons";

import classNames from "classnames";

// styles
import useStyles from "./styles";
import logo from '../../pages/login/logo.png';

// components
import { Typography } from "../Wrappers/Wrappers";
import Profile from "../Profile";

// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
} from "../../context/LayoutContext";
import { useUserDispatch, signOut } from "../../context/UserContext";
import { useQuery } from '@apollo/react-hooks';
import { GET_BY_USER } from "../../queries/access";
import { GET_BY_USER_ID } from "../../queries/user";

export default function Header(props) {
  var classes = useStyles();

  // global
  var layoutState = useLayoutState();
  var layoutDispatch = useLayoutDispatch();
  var userDispatch = useUserDispatch();

  // local
  var [profileMenu, setProfileMenu] = useState(null);
  var [publisherMenu, setPublisherMenu] = useState(null);
  var [activePublisher, setActivePublisher] = useState(localStorage.getItem('publisher-active'));
    
  const handleChange = (e) => {
    if(e && e.target){
      localStorage.setItem('publisher-active', e.target.value);
      publisherList.forEach(publisher =>{ 
        if(publisher.id === e.target.value){
          publisher.services.forEach(service=>{
            localStorage.setItem('publisher-'+service.name, service.enabled);
          });
        }
      });
      setActivePublisher(e.target.value);
      window.location.reload();
    }
  }

  const { loading, error, data } = useQuery(GET_BY_USER, {
    variables: { user: localStorage.getItem('id_user') },
  });

  const { loading: loadingUser, error: errorUser, data: dataUser } = useQuery(GET_BY_USER_ID, {
    variables: { id: localStorage.getItem('id_user') },
  });

  let publisherList = [];
  const activePublisherRow = [];
  if(data){
    data.accesses.forEach(access => {
        publisherList.push({ id: access.site.publisherId, value: access.site.name, services: access.site.services });
    });

    if(publisherList)
    publisherList.sort((a, b) => { if(a.value < b.value) return -1; if(a.value > b.value) return 1; return 0; });

    if(localStorage.getItem('publisher-active') === '' && publisherList && publisherList[0]){
      localStorage.setItem('publisher-active', publisherList[0].id);
      publisherList[0].services.forEach(service=>{
        localStorage.setItem('publisher-'+service.name, service.enabled);
      })
      localStorage.setItem('publisher-news', publisherList[0].id);
    }

    activePublisherRow.push(publisherList.filter(pub => pub.id === localStorage.getItem('publisher-active'))[0]);


  }

  return (
    (error ?      
    signOut(userDispatch, props.history):
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <IconButton
          color="inherit"
          onClick={() => toggleSidebar(layoutDispatch)}
          className={classNames(
            classes.headerMenuButton,
            classes.headerMenuButtonCollapse,
          )}
        >
          {layoutState.isSidebarOpened ? (
            <ArrowBackIcon
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse,
                ),
              }}
            />
          ) : (
            <MenuIcon
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse,
                ),
              }}
            />
          )}
        </IconButton>
        <Typography variant="h6" weight="medium" className={classes.logotype}>
          <img src={logo} alt="logo" /> <small>Adireto PUB</small>
        </Typography>
        <div className={classes.grow} />

        <IconButton
          aria-haspopup="true"
          color="inherit"
          className={classes.headerMenuButton}
          aria-controls="publisher-menu"
          onClick={e => setPublisherMenu(e.currentTarget)}
        >
          
            <Typography variant="subtitle1" style={{ padding: '5px' }}>
            [{(activePublisherRow[0] ? activePublisherRow[0].value: 'Select Publisher')}]
            </Typography>
            <Divider />
          
          <PublisherChange classes={{ root: classes.headerIcon }} />
        </IconButton>
        <IconButton
          aria-haspopup="true"
          color="inherit"
          className={classes.headerMenuButton}
          aria-controls="profile-menu"
          onClick={e => setProfileMenu(e.currentTarget)}
        >
          <AccountIcon classes={{ root: classes.headerIcon }} />
        </IconButton>

        <Menu
          id="profile-menu"
          open={Boolean(profileMenu)}
          anchorEl={profileMenu}
          onClose={() => setProfileMenu(null)}
          className={classes.headerMenu}
          classes={{ paper: classes.profileMenu }}
          disableAutoFocusItem
        >
          <div className={classes.profileMenuUser}>
            <Typography variant="h4" weight="medium">
              {localStorage.getItem('name')}
            </Typography>
            <Typography
              className={classes.profileMenuLink}
              component="a"
              color="primary"
            >
              {localStorage.getItem('email')}
            </Typography>
          </div>

          {
          (loadingUser ? <div>Loading</div> :
          errorUser ? <div>Error on users</div>:
            <Profile dataUser={dataUser}/>
          )
          }
          
          <div className={classes.profileMenuUser}>
            <Typography
              className={classes.profileMenuLink}
              color="primary"
              onClick={() => signOut(userDispatch, props.history)}
            >
              Sign Out
            </Typography>
          </div>
        </Menu>
        {
        (loading ? <div>Loading</div> :
        error ? <div>Error on publishers</div>:
        
        <Menu
          id="publisher-menu"
          open={Boolean(publisherMenu)}
          anchorEl={publisherMenu}
          onClose={() => setPublisherMenu(null)}
          className={classes.headerMenu}
          classes={{ paper: classes.publisherMenu }}
          disableAutoFocusItem
        >
          <div className={classes.profileMenuUser}>
            <Typography variant="h4" weight="medium">
              Change Publisher
            </Typography>
            <InputLabel style={{ fontSize : 12, marginTop: 15 }}>Publisher</InputLabel>
            <Select fullWidth id="publisherChangeId"
              labelId="select-publisher"
              onChange={handleChange} value={activePublisher}
            >
              {
                (publisherList ?
                  publisherList.map(item => <MenuItem value={item.id} key={item.id}>{item.value}</MenuItem>) : (<></>))
              }
            </Select>
          </div>
        </Menu>
        )
        }

      </Toolbar>
    </AppBar>
    )
  );
}
